// removed by extract-text-webpack-plugin
module.exports = {"logo":"_2Scy9-1B693FZ5wPq9eaLB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LadderLogo/LadderLogo.mod.css
// module id = 1006
// module chunks = 0